import MuiDialogActions from '@mui/material/DialogActions';

import { styled } from 'helpers';

export const SimpleModalActionsStyled = styled(MuiDialogActions)`
  &.MuiDialogActions-root {
    padding: 30px 0px;
    margin: 0 32px;
    border-top: 1px solid ${({ theme }) => theme.palette.grey['A100']};
  }

  // target only immediate descendants, so it doesn't affect the custom component children's
  & > button {
    height: 40px;

    &:last-of-type {
      margin-left: 16px;
    }

    &:first-of-type:nth-last-of-type(3) {
      margin-right: auto;
    }
  }
`;
